import AssessmentResult from './AssessmentResult';

export default AssessmentResult;



// WEBPACK FOOTER //
// ./src/pages/gdpr-assessment-tool/containers/AssessmentResult/index.js